import LocalDevStudentUser from "../api/mocks/getStudentUserSession.json";
import LocalDevTeacherUser from "../api/mocks/getTeacherUserSession.json";
import { SessionEntityType, StudentUserInfo, TeacherUserInfo, UserSession } from "../api/models/session";
import { mocksResponse } from "../utils/env";

// these student ID's are necessary to work with local API
export const mockId = "52338d4b89f0de000000dddd";
export const altMockId = "52338d4b89f0de000000000d";
export class UserManager {
  private static _instance: UserManager = new UserManager();
  static get instance(): UserManager {
    return this._instance;
  }

  private _user: UserSession | undefined;
  get user(): UserSession | undefined {
    return this._user;
  }
  set user(user: UserSession | undefined) {
    this._user = user;
  }

  get userId(): string | undefined {
    if (!this._user) return undefined;
    return this._user.type === "teacher" ? this._user.teacher._id : this._user.student._id;
  }

  reset() {
    // reset any previously set user info
    this._user = undefined;
  }

  async syncUser(startupEntityType: SessionEntityType, dataProvider: () => Promise<UserSession>) {
    if (mocksResponse()) {
      // return mocked user data because of CORS issues in dev
      this._user = (startupEntityType === "teacher" ? LocalDevTeacherUser : LocalDevStudentUser) as UserSession;

      // Use default mock id in Chrome, otherwise use alt mock id for any other browser
      // Note: Only tested on Chrome/Safari. The reliablity of identifying browser using this technique has not been determined.
      if (navigator.userAgent.indexOf("Chrome") === -1) {
        this._user.type === "student" ? (this._user.student._id = altMockId) : (this._user.teacher._id = altMockId);
      }

      return this._user;
    }

    this._user = await dataProvider();
    return this._user;
  }

  getEntityId(): string | undefined {
    return this.userId;
  }

  getEntityType() {
    return this._user?.type;
  }

  getEntity(): StudentUserInfo | TeacherUserInfo | undefined {
    return this._user?.type === "teacher" ? this._user.teacher : this._user?.student;
  }

  getSchoolId(): string | undefined {
    if (this._user) {
      switch (this._user.type) {
        case "student":
          return this._user.student?.schoolIds?.[0];
        case "teacher":
          return this._user.teacher?.schoolId;
      }
    }
  }
}
